/**
 * RefreshOverlay - Modal overlay component for refresh operations
 *
 * Shows a spinner with status text while refreshing data.
 * Designed to overlay modal content without closing the modal.
 */

import { Spinner } from 'react-bootstrap';

interface RefreshOverlayProps {
  isRefreshing: boolean;
  currentItem?: string; // e.g., "data types", "clinics", "devices"
  message?: string; // Custom message override
}

export default function RefreshOverlay({
  isRefreshing,
  currentItem,
  message,
}: RefreshOverlayProps) {
  if (!isRefreshing) return null;

  const displayMessage = message || (currentItem ? `Refreshing ${currentItem}...` : 'Refreshing data...');

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1050,
        borderRadius: 'inherit',
      }}
    >
      <Spinner
        animation="border"
        variant="primary"
        style={{ width: '3rem', height: '3rem' }}
      />
      <p
        className="mt-3 text-muted"
        style={{ fontSize: '0.95rem', fontWeight: 500 }}
      >
        {displayMessage}
      </p>
    </div>
  );
}
